<template>
<modal name="pricing" style="overflow-y: scroll" height="auto" :width="850" :pivotX="0" :pivotY=".15">
  <aside class="window window--large choose-plan">
    <header class="window__header">
      <h1 class="window__title">Choose a plan</h1>
    </header>
    <div class="button button--secondary button--expand" @click="togglePlanTerm">Toggle Payment Term</div>

    <section class="window__content pricing">
      <ul class="pricing__list" v-if="planTerm == 'month'">
        <li class="pricing__item" v-for="plan in getMonthlyPlans">
          <article class="plan" v-on:click="choosePlan(plan)">
            <header class="plan__header">
              <h1 class="plan__type">{{ plan.name }}</h1>
              <h2 class="plan__price">
                <span class="plan__price__value">
                  <span class="plan__price__currency">$</span>{{ plan.price / 100 }}
                </span>
                <span class="plan__price__frequency">/ month </span>
              </h2>
            </header>

            <ul class="plan__properties plan__properties--expanded">
              <li class="plan__property" v-for="property in plan.properties">
                {{ property }}
              </li>
            </ul>
          </article>
        </li>
      </ul>
      <ul class="pricing__list" v-if="planTerm == 'year'">
        <li class="pricing__item" v-for="plan in getYearlyPlans">
          <article class="plan" v-on:click="choosePlan(plan)">
            <header class="plan__header">
              <h1 class="plan__type">{{ plan.name }}</h1>
              <h2 class="plan__price">
                <span class="plan__price__value">
                  <span class="plan__price__currency">$</span>{{ plan.price / 100 }}
                </span>
                <span class="plan__price__frequency">/ year</span>
              </h2>
            </header>

            <ul class="plan__properties">
              <li class="plan__property" v-for="property in plan.properties">
                {{ property }}
              </li>
            </ul>
          </article>
        </li>
      </ul>
    </section>
    <router-link @click.native="$modal.hide('pricing')" to="/quote" class="link link--small pricing__link">Need more than 10 Users? Apply for an Enterprise Account!</router-link>
  </aside>

</modal>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'Pricing',
  methods: {
    hide () {
      this.$modal.hide('pricing')
      this.$modal.show('payment-options')
    },
    highlightPlan(planName){
      this.highlighted = planName;
    },
    clearHighlight(){
      this.highlighted = null;
    },
    choosePlan(plan){
      this.$modal.hide('pricing');
      if (plan.id != 1){
        this.$modal.show('payment-options', plan)
      }
    },
    togglePlanTerm () {
      if (this.planTerm == 'month') {
        this.planTerm = 'year'
      } else {
        this.planTerm = 'month'
      }
    }
  },
  computed: {
    ...mapState(['plans', 'planChosen']),
    getMonthlyPlans () {
      return this.plans.filter((plan) => {
        return plan.term == 'month' && plan.id > this.planChosen.id && plan.short_name !== 'enterprise-monthly'
      })
    },
    getYearlyPlans () {
      return this.plans.filter((plan) => {
        return plan.term == 'year' && plan.id > this.planChosen.id && plan.short_name !== 'enterprise-yearly'
      })
    }
  },
  data () {
    return {
      hoverListener: false,
      highlighted: null,
      planTerm: 'month'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/Pricing.vue